import { z } from "zod";

const commaSeparatedStrings = z
  .string()
  .transform((s) => s.split(","))
  .pipe(z.string().array().min(1));

export const Request = z.object({
  organisationId: commaSeparatedStrings.nullish().default(null),
  locationId: commaSeparatedStrings.nullish().default(null),
  productId: commaSeparatedStrings.nullish().default(null),
});
